import {ReloadButton,} from '@flexinet/ui-components';
import {Box,} from '@mantine/core';
import { useQueryClient } from '@tanstack/react-query';
import { applicationProductsKeys } from '../hooks/useApplicationProductsQuery';

export const ReloadRecordsButton = () => {
    const queryClient = useQueryClient();

    const handleReload = () => {
        queryClient.invalidateQueries({ queryKey: applicationProductsKeys.all });
    };

    return (
        <Box mx='s'>
            <ReloadButton onClick={handleReload}/>
        </Box>
    );
};
